import { FunctionComponent } from "react"
import { IconType } from "react-icons"
import { AiOutlineWifi } from "react-icons/ai"
import { FaMoneyCheckAlt } from "react-icons/fa"
import { FaArrowTrendUp, FaPhone } from "react-icons/fa6"
import { FiClock } from "react-icons/fi"
import { HiOutlineBuildingOffice } from "react-icons/hi2"
import { IoMdSettings } from "react-icons/io"
import { IoJournal } from "react-icons/io5"
import { TbSquareLetterZ } from "react-icons/tb"
import styled from "styled-components"
import Icon from "./Icon"

/**
 * This file should be kept in sync between:
 * - bell
 * - gpr-front
 * - doorking-front
 * - management-fees-front
 * - access-control-front
 * - users-front
 * (And the equivilent changes should be made to Hero and coalesce.)
 */

interface IItem {
	icon: IconType
	text: string
	href?: string
}
const staticItems: IItem[] = [
	{
		icon: AiOutlineWifi,
		text: "Internet Management",
		href: "https://internet.norhart.com",
	},
	{
		icon: FiClock,
		text: "Access Control",
		href: "https://hero-access-control.norhart.com",
	},
	{
		icon: FaPhone,
		text: "Phone Entry",
		href: "https://hero-doorking.norhart.com",
	},
	{
		icon: FaMoneyCheckAlt,
		text: "Monthly Fees",
		href: "https://hero-management-fees.norhart.com/",
	},
	{
		icon: IoJournal,
		text: "GPR Journals",
		href: "https://hero-gpr.norhart.com/",
	},
	{
		icon: IoMdSettings,
		text: "Settings",
		href: "https://hero-users.norhart.com/",
	},
	{
		icon: HiOutlineBuildingOffice,
		text: "Rent Manager",
		href: "https://norhart.rmx.rentmanager.com/",
	},
	{
		icon: FaArrowTrendUp,
		text: "Spherexx",
		href: "https://www.sweetspot.ws/easy/pages/login.asp",
	},
	{
		icon: TbSquareLetterZ,
		text: "Zego",
		href: "https://payments.gozego.com/login",
	},
]

interface ISideMenu {
	showNavBar: boolean
}
const SideMenu: FunctionComponent<ISideMenu> = ({ showNavBar }) => {
	return (
		<SideNavBar showNavBar={showNavBar}>
			{staticItems.map(({ icon, text, href }) => {
				return (
					<StyledGroupItem key={text}>
						<Icon component={icon} />
						<Link href={href} key={text}>
							{text}
						</Link>
					</StyledGroupItem>
				)
			})}
		</SideNavBar>
	)
}
export default SideMenu

interface ISideNavBar {
	showNavBar: boolean
}
const SideNavBar = styled.div<ISideNavBar>`
	position: fixed;
	height: 100%;
	width: 220px;
	z-index: 100;
	transition: all 400ms ease-in-out;
	background-color: #212529;
	${(props) => (props.showNavBar ? null : "transform: translateX(-220px)")}
`

interface IGroupItem {
	active?: boolean
}
const StyledGroupItem = styled.div<IGroupItem>`
	cursor: pointer;
	display: flex;
	height: 31.25px;
	align-items: center;
	text-decoration: none;
	color: #a5a5a5;
	&:hover {
		transition: background-color 0s, ease 0s;
		color: white;
	}
	&:focus,
	&:visited,
	&:link,
	&:active {
		text-decoration: none;
	}
	a {
		margin-left: 0;
	}
	${({ active }) => (active ? "background: #434343" : "null")}
`

const Link = styled.a`
	cursor: pointer;
	display: flex;
	height: 31.25px;
	margin-left: 16px;
	align-items: center;
	text-decoration: none;
	color: #a5a5a5;
	&:hover {
		transition: background-color 0s, ease 0s;
		color: white;
	}
	&:focus,
	&:visited,
	&:link,
	&:active {
		text-decoration: none;
	}
`
